<template>
  <div class="profit-details-page">
    <div class="inquire-module" id="page-top">
      <a-row>
        <a-col>
          <!-- <a-range-picker v-model="filtrateDate" @change="changeData" /> -->
          <a-range-picker :disabled-date="disabledDate" :disabled-time="disabledRangeTime" format="YYYY-MM-DD"
            v-model="filtrateDate" @change="changeData" />
        </a-col>
        <a-col>
          <span>会计科目：</span>
          <span>{{ accountingObj.name }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="profit-details-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
        :scroll="{x:1000, y: (tableHeight) }" bordered>
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{  index+1 }}</span>
        </template>
        <template slot="voucherType" slot-scope="text">
          <span>{{ getTypeName(text) }}</span>
        </template>
        <!-- 底部合计 -->
        <template slot="footer">
          <a-table :columns="footerColumns" :dataSource="footerDataSource" :pagination="false" :showHeader="false"
            rowKey="id" class="table-footer-detail" bordered>
            <template slot="serialNum">
              <span>小计</span>
            </template>
          </a-table>
        </template>
      </a-table>
    </div>
    <!-- <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :default-current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div> -->
  </div>
</template>
<script>
import pick from "lodash.pick";
import moment from "moment";
import { tableWidth } from "@/mixins/tableWidth";
import { getSellReportList } from "@/utils/api";
export default {
  name: "profitDetails",
  mixins: [tableWidth],
  data() {
    return {
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          fixed: "left",
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          width: 250,
          title: "单据编号",
          fixed: "left",
          dataIndex: "voucherCode",
          scopedSlots: { customRender: "voucherCode" },
        },
        {
          tdNum: 150,
          title: "单据类型",
          dataIndex: "voucherType",
          scopedSlots: { customRender: "voucherType" },
        },
        {
          width: 200,
          title: "摘要",
          dataIndex: "digest",
        },
        {
          width: 200,
          title: "往来单位",
          dataIndex: "contactCustomerName",
        },
        {
          tdNum: 150,
          title: "增加金额",
          align: "right",
          dataIndex: "addAmount",
        },
        {
          tdNum: 150,
          title: "减少金额",
          align: "right",
          dataIndex: "reduceAmount",
        },
        {
          tdNum: 150,
          title: "余额",
          align: "right",
          dataIndex: "balance",
        },
        {
          width: 200,
          title: "备注",
          fixed: "right",
          dataIndex: "remark",
        },
      ],
      dataSource: [],
      footerDataSource: [
        {
          serialNum: "",
          voucherCode: "",
          voucherType: "",
          digest: "",
          contactCustomerName: "",
          addAmount: "",
          reduceAmount: "",
          balance: "",
          remark: "",
        },
      ],
      typeList: [
        {
          id: 1,
          name: "采购入库",
        },
        {
          id: 2,
          name: "销售退货入库",
        },
        {
          id: 3,
          name: "其他入库",
        },
        {
          id: 4,
          name: "库存报溢",
        },
        {
          id: 5,
          name: "销售出库",
        },
        {
          id: 6,
          name: "采购退货出库",
        },
        {
          id: 7,
          name: "其他出库",
        },
        {
          id: 8,
          name: "库存报损",
        },
        {
          id: 9,
          name: "库存调拨 ",
        },
        {
          id: 10,
          name: "库存组装拆卸单",
        },
        {
          id: 11,
          name: "付款单",
        },
        {
          id: 12,
          name: "收款单",
        },
        {
          id: 13,
          name: "其他支出单",
        },
        {
          id: 14,
          name: "其他收入单",
        },
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 100,
      },
      formData: {
        endTime: undefined,
        startTime: undefined,
        incomeStatementId: null,
      },
      filtrateDate: [],
      accountingObj: {},
      tableHeight: "",
      contentHeight: "",
      urlList: {
        details:
          "/finance/api/financeIncomeStatement/listFinanceIncomeStatementDetail",
      },
    };
  },
  activated() {
    // 表格高度计算
    let _that = this
    setTimeout(function() {
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8;
      _that.tableHeight = _that.contentHeight - tdHeight * 2;
    }, 50)
    this.accountingObj = JSON.parse(sessionStorage.getItem("accountingObj"));
    this.formData.incomeStatementId = this.accountingObj.id;
    this.formData.startTime = this.accountingObj.startTime;
    this.formData.endTime = this.accountingObj.endTime;
    this.filtrateDate = [
      moment(this.accountingObj.startTime),
      moment(this.accountingObj.endTime),
    ];
    this.getProfitListDetails();
  },
  methods: {
    moment,
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },

    disabledRangeTime(_, type) {
      if (type === "start") {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },
    // 获取类型名称
    getTypeName(e) {
      let name = "";
      this.typeList.map((item) => {
        if (e == item.id) {
          name = item.name;
        }
      });
      return name;
    },
    changeData(date, dateString) {
      this.filtrateDate = date;
      this.formData.startTime = dateString[0];
      this.formData.endTime = dateString[1];
      this.getProfitListDetails();
    },
    // 页面变化时回调
    onChangeIpagination(current) {
      this.ipagination.current = current;
      //   this.getMenuList()
    },
    // 一页显示条数变化时回调
    onShowSizeChange(current, pageSize) {
      this.ipagination.current = current;
      this.ipagination.pageSize = pageSize;
      //   this.getMenuList()
    },
    getProfitListDetails() {
      let params = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        endTime: this.formData.endTime,
        startTime: this.formData.startTime,
        incomeStatementId: this.formData.incomeStatementId,
      };
      let data = {};
      this.$store.state.isLoding = true;
      getSellReportList(this.urlList.details, params, {}, data).then((res) => {
        if (res.code == 200) {
          this.dataSource = res.result;
          this.ipagination.total = parseInt(res.result.total);
          this.$store.state.isLoding = false;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.profit-details-page {
  .inquire-module {
    padding: 24px 30px;
    background-color: #ffffff;
    .ant-row {
      display: flex;
      align-items: center;
      .ant-col {
        padding-right: 100px;
      }
    }
  }
  .profit-details-table {
    margin-top: 16px;
    background-color: #ffffff;
  }
  // 下部列表
  .pagination-box {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
  }
}
</style>